import React from 'react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import Button from '@atlaskit/button';
import LockIcon from '@atlaskit/icon/glyph/lock-filled';
import UnlockIcon from '@atlaskit/icon/glyph/unlock';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { ButtonContent } from '../../common/ui/styled';

import type { Props } from './types';

export const Loading = (props: Props) => {
	const { initialValue } = props;
	const Icon = initialValue ? LockIcon : UnlockIcon;

	return (
		<Button
			appearance="subtle"
			spacing="default"
			isDisabled
			iconBefore={
				// @ts-expect-error - TS2739 - Type '{ children: Element; }' is missing the following properties from type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { isActive: boolean; hasSecurityLevel: boolean; }, any>>': isActive, hasSecurityLevel
				<LoadingButtonContent>
					<Icon label="" />
				</LoadingButtonContent>
			}
			interactionName="auto-generated.jira-issue-field-security-level.ui.loading.button"
		/>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LoadingButtonContent = styled(ButtonContent)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.icon.disabled', colors.N30),
});
